/**
 * Ir_news
 * @constructor
 */
class Ir_news {
  constructor() {}
  /**
   * コモン
   */
  init() {
    
    //News　アコーディオン
    $('.js-news-acc-btn').on('click', function () {
      $(this).toggleClass('is-active');
      $(this).next().stop().slideToggle();
    })
    
    //News　アコーディオン
    $('.js-news-side-toggle').on('click', function () {
      $(this).toggleClass('is-active');
      $(this).next().stop().slideToggle();
    })
    
    //News　ニュースのタブ切り替え
    $('.js-news-tab').click(function() {
      var index = $('.m-news-tab__item').index(this);
      $('.m-news-tab__item, .m-news__list').removeClass('is-active');
      $(this).addClass('is-active');
      $('.m-news__list').eq(index).addClass('is-active');
    });
    
  }
}

export default Ir_news;